import { Box, useTheme } from '@mui/material'
import { GridColumns, GridNativeColTypes } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import GenericTable from 'src/components/table/GenericTable'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'
import ROVVideoSyncDialog from './ROVVideoSyncDialog'
import IdentityUserSyncDialog from 'src/screens/customer/users/IdentityUserSyncDialog'

const DataSyncScreen = () => {
  const { t } = useTranslation('data-sync')
  const { showDialog } = useDialogCtx()
  const theme = useTheme()

  const syncJobs = useMemo(
    () => [
      {
        id: 'rov-videos',
        name: t('rov-videos-title'),
        description: t('rov-videos-description'),
      },
      {
        id: 'identity-users',
        name: t('identity-users-title'),
        description: t('identity-users-description'),
      },
    ],
    [t],
  )

  const handleRowClick = ({ row }: { row: (typeof syncJobs)[number] }) => {
    if (row.id === 'rov-videos') {
      showDialog(ROVVideoSyncDialog, {
        title: t('rov-videos-title'),
        opts: { maxWidth: 'lg', fullWidth: true },
      })
    } else if (row.id === 'identity-users') {
      showDialog(IdentityUserSyncDialog, {
        title: t('identity-users-title'),
        opts: { maxWidth: 'lg', fullWidth: true },
      })
    }
  }

  const columns: GridColumns = useMemo(
    () => [
      {
        field: 'name',
        headerName: t('col-name'),
        flex: 1,
        minWidth: 180,
      },
      {
        field: 'description',
        headerName: t('col-description'),
        flex: 3,
        sortable: false,
        type: 'string' as GridNativeColTypes,
      },
    ],
    [t],
  )

  return (
    <CommonPageLayout titleSection={{ title: t('page-title') }}>
      <Box padding="8px" bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius="4px">
        <GenericTable
          id="data-sync-jobs"
          data={syncJobs}
          columns={columns}
          getRowId={row => row.id}
          enableToolbar={false}
          enablePagination={false}
          autoHeight
          getRowHeight={() => 44}
          onRowClick={handleRowClick}
          sx={{ cursor: 'pointer' }}
        />
      </Box>
    </CommonPageLayout>
  )
}

export default DataSyncScreen
